import RcDomainMap from "../../../common/RcDomainMap.js";
import VehicleData from "./VehicleData.js";

export default class VehicleDataMap extends RcDomainMap {

  static MODEL_NAME = "VehicleDataMap";

  constructor(domain, data) {
    super(domain, data, VehicleDataMap.MODEL_NAME);
  }

  getVehicleData(key) {
    var value = super.get(key);
    return new VehicleData(this.domain, value);
  }

  find() {
    var keys = this.keys();
    var found = new VehicleDataMap(this.domain, {});
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getVehicleData(key);
      if (item.isNew()) {
        found.add(item);
      } else {
        var data = this.domain.vehicles().vehicleData().findById(key);
        item = new VehicleData(this.domain, data);
        if (!item.isNew()) {
          found.add(item);
        }
      }
    }
    return found;
  }

  populate() {
    var found = this.find();
    this.addAll(found);
    return this;
  }

  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      values.push(this.getVehicleData(keys[index]));
    }
    return values;
  }

  // The row holding the latest value for what was measured, or a new empty row
  // when the asset has nothing recorded for it yet. An asset should only ever
  // hold one row per key, but the newest wins if duplicates ever appear.
  forKey(key) {
    var found = new VehicleData(this.domain);
    var list = this.list();
    for (var index = 0; index < list.length; index++) {
      var item = list[index];
      if (!item.isKey(key)) {
        continue;
      }
      if (found.isNew() || item.recordedOn() > found.recordedOn()) {
        found = item;
      }
    }
    return found;
  }

  // Whether a value has been recorded for what was measured. Tests the value
  // rather than whether the row has been persisted, so a row built in memory and
  // not yet saved still counts.
  hasKey(key) {
    return this.forKey(key).hasValue();
  }

  odometer() {
    return this.forKey(VehicleData.Values.Keys.Odometer);
  }

  copy() {
    var data = this._copy();
    return new VehicleDataMap(this.domain, data);
  }
}
